export default payload => ({ $event: payload });



// WEBPACK FOOTER //
// ./client/app/common/utils/eventEmitter.js